/*
 * Copyright (C) 2026 Nex4Nova (Geoblast group)
 * SPDX-License-Identifier: Proprietary
 */
import { createContext, useCallback, useContext, useState } from 'react';

const MIN_ZOOM = 0.1;
const DEFAULT_ZOOM = 5;

const ZoomContext = createContext({
  zoom: DEFAULT_ZOOM,
  zoomLevel: DEFAULT_ZOOM,
  setZoom: () => {},
  setZoomLevel: () => {},
  resetZoom: () => {},
});

export function ZoomProvider({ children }) {
  const [zoom, setZoomState] = useState(DEFAULT_ZOOM);

  const setZoom = useCallback((value) => {
    setZoomState(Math.max(MIN_ZOOM, value));
  }, []);

  const setZoomLevel = useCallback((value) => {
    setZoomState(Math.max(MIN_ZOOM, value));
  }, []);

  const resetZoom = useCallback(() => {
    setZoomState(DEFAULT_ZOOM);
  }, []);

  return (
    <ZoomContext.Provider value={{ zoom, zoomLevel: zoom, setZoom, setZoomLevel, resetZoom }}>
      {children}
    </ZoomContext.Provider>
  );
}

export function useZoom() {
  return useContext(ZoomContext);
}

export function useZoomContext() {
  return useContext(ZoomContext);
}
